import React, { useEffect, useMemo, useState } from "react";
import { ColumnsType } from "antd/lib/table";
import { Button, Tooltip } from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Table from "../../../components/Table";
import api from "../../../services/api";
import AddHoursFactory from "./AddHoursFactory";

export interface ICustomersHoursFactory {
  id: string;
  value: number;
  customer_id: string;
  name: string;
  customer: { name: string; id: string };
}

const CustomersHoursFactory = () => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedHoursFactory, setSelectedHoursFactory] = useState<
    ICustomersHoursFactory | undefined
  >(undefined);
  const [hoursFactory, setHoursFactory] = useState<ICustomersHoursFactory[]>(
    [],
  );

  const { t } = useTranslation(["customers"]);

  const openModal = (hours_factory?: ICustomersHoursFactory) => {
    if (hours_factory) {
      setSelectedHoursFactory(hours_factory);
    }
    setVisible(true);
  };

  useEffect(() => {
    setLoading(true);
    api
      .get<ICustomersHoursFactory[]>("/hours_factory")
      .then(response => {
        setHoursFactory(response.data);
      })
      .finally(() => setLoading(false));
  }, []);
  const columns: ColumnsType<ICustomersHoursFactory> = [
    {
      title: "Cliente",
      dataIndex: "customers",
      key: "customers",
      render: (_, record) => {
        return record?.name;
        /* return (
          <UserAvatar name={record?.customer.name || ""} url="" size={36} />
        ); */
      },
    },
    {
      title: "Valor",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Ações",
      key: "actions",
      render: (_, record) => {
        return (
          <Tooltip title="Editar">
            <Button
              onClick={() => openModal(record)}
              icon={<EditOutlined />}
              type="link"
            />
          </Tooltip>
        );
      },
    },
  ];

  const hoursFactoryExtraAction = useMemo(() => {
    return (
      <Tooltip title={t("Criar")}>
        <Button
          icon={<PlusCircleOutlined />}
          type="link"
          size="large"
          onClick={() => setVisible(true)}
        />
      </Tooltip>
    );
  }, [t]);
  const handleClose = (hours_factory?: ICustomersHoursFactory) => {
    setSelectedHoursFactory(undefined);

    if (hours_factory) {
      const hoursFactoryIndex = hoursFactory.findIndex(
        hours => hours.id === hours_factory.id,
      );

      if (hoursFactoryIndex >= 0) {
        const newHoursFactory = [...hoursFactory];
        newHoursFactory[hoursFactoryIndex] = hours_factory;
        setHoursFactory(newHoursFactory);
      } else {
        setHoursFactory(old => [...old, hours_factory]);
      }
    }

    setVisible(false);
  };
  return (
    <>
      <AddHoursFactory
        selectHoursFactory={selectedHoursFactory}
        visible={visible}
        handleClose={handleClose}
        hoursFactory={hoursFactory}
      />
      <Table
        columns={columns}
        data={hoursFactory}
        loading={loading}
        title="Valores de Hora Fabrica"
        extraActions={hoursFactoryExtraAction}
      />
    </>
  );
};
export default CustomersHoursFactory;
